import BottomSheet from "../../Common/BottomSheet";
import { lg, shortenAddress } from "@/utils/generalUtils";
import { SortList } from "@/utils/marketplace/sortList";
import GreenTick from "@/assetsV3/marketplace/GreenTick";
import { useSolanaWallets } from "@privy-io/react-auth";
import SolBalanceIcon from "@/assetsV3/Wallet/SolIcon";
import PrivyIcon from "@/assetsV3/Wallet/PrivyIcon";
import { WalletTypeEnum } from "@/types/enums/WalletTypeEnum";
import SolanaIcon from "@/assetsV3/Wallet/SolanaIcon";
import useSolanaTransaction from "@/callbacks/useSolanaTransaction";
import { useEffect, useState } from "react";
import { setWallet } from "@/redux/slice/walletSlice";
import { useDispatch } from "react-redux";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import GradientTick from "@/assetsV3/GradientTick";

interface Props {
  bottomSheetState: boolean;
  setSelectedWallet: (val: string) => void;
  selectedWallet: string;
  handleSheetChange: (isOpen: boolean) => void;
}

const WalletSelectionSheet: React.FC<Props> = ({
  handleSheetChange,
  selectedWallet,
  setSelectedWallet,
  bottomSheetState,
}) => {
  const { wallets } = useSolanaWallets();
  const { getMultiWalletSolBalance } = useSolanaTransaction();
  const [balanceArray, setBalanceArray] = useState<number[]>();
  const dispatch = useDispatch();

  useEffect(() => {
    const run = async () => {
      const _balanceArray = await getMultiWalletSolBalance(
        wallets.map((item) => item.address)
      );
      setBalanceArray(_balanceArray ?? []);
    };
    if (wallets.length > 0) {
      run();
    }
  }, [wallets.length]);

  return (
    <>
      {window.innerWidth < lg ? (
        <BottomSheet isOpen={bottomSheetState} onChange={handleSheetChange}>
          <div className="flex flex-col gap-4">
            <h1 className="text-outext-main font-bold text-[21px]">Wallet</h1>
            {(!wallets || wallets.length === 0) &&
              [1, 1, 1].map((wallet, index) => {
                return (
                  <SkeletonTheme
                    key={index}
                    baseColor="#373737"
                    highlightColor="#C0C0C0"
                  >
                    <div
                      key={index}
                      className={`py-3 pr-3 pl-6 rounded-lg  flex justify-between items-center gap-5 cursor-pointer `}
                    >
                      <Skeleton
                        count={1}
                        width={"24px"}
                        height={"24px"}
                        style={{ borderRadius: "8px" }}
                      />
                      <div className="flex flex-1 flex-col text-base gap-1">
                        <div className="flex gap-1 items-center">
                          <span className="font-bold text-outext-main text-base">
                            <Skeleton
                              count={1}
                              width={"75px"}
                              height={"20px"}
                              style={{ borderRadius: "8px" }}
                            />
                          </span>
                        </div>
                        <p className="text-outext-disabled font-normal">
                          <Skeleton
                            count={1}
                            width={"75px"}
                            height={"20px"}
                            style={{ borderRadius: "8px" }}
                          />
                        </p>
                      </div>
                    </div>
                  </SkeletonTheme>
                );
              })}
            <div className="flex flex-col gap-y-6">
              {wallets.map((wallet, index) => {
                return (
                  <>
                    <div
                      key={index}
                      onClick={() => {
                        const walletData = {
                          address: wallet.address,
                          walletConnectType: wallet.walletClientType,
                        };
                        dispatch(setWallet(walletData));
                        setSelectedWallet(wallet.address);
                        handleSheetChange(false);
                      }}
                      className={`rounded-lg p-3 pl-6 flex justify-between items-center gap-5 cursor-pointer hover:bg-outgray-graylighter ${
                        selectedWallet === wallet.address
                          ? "bg-outgray-graylighter"
                          : ""
                      } `}
                    >
                      {wallet.walletClientType === WalletTypeEnum.PHANTOM ? (
                        <SolBalanceIcon className="fill-outprimary-darker" />
                      ) : (
                        <PrivyIcon
                          width={"24px"}
                          height={"30.9px"}
                          className="fill-outprimary-darker"
                        />
                      )}
                      <div className="flex flex-1 flex-col text-base">
                        <div className="flex gap-1 items-center">
                          <SolanaIcon
                            width={20}
                            height={20}
                            className="fill-outprimary-darker"
                          />
                          <span className="font-bold text-outext-main text-base">
                            {Math.trunc((balanceArray?.[index] ?? 0) * 100) /
                              100}
                          </span>
                        </div>
                        <p className="text-outext-disabled font-normal">
                          {shortenAddress(wallet.address?.toString() ?? "")}
                        </p>
                      </div>
                      {selectedWallet === wallet.address ? (
                        <div className="flex justify-center items-center h-6 w-6">
                          <GradientTick />
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        </BottomSheet>
      ) : (
        <></>
      )}
    </>
  );
};

export default WalletSelectionSheet;
